import { render, staticRenderFns } from "./CampaignCardV2Skeleton.vue?vue&type=template&id=0ba06d80&"
import script from "./CampaignCardV2Skeleton.vue?vue&type=script&lang=js&"
export * from "./CampaignCardV2Skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports